export const getPathFromContext = (chatCtx) => {
  // const agentContext = chatCtx.agentContextMapping.find(mapping => mapping.agentId === chatCtx.agentId);
  const context = 'agentmgr';
  return context.startsWith('/') ? context.substring(1) : context;
}; 